<div class="attachment-note-body" [ngClass]="activityCtrl?.activityState">
  <textarea cdkTextareaAutosize [cdkAutosizeMinRows]="1" id="description" name="note"
  [disabled]="!canEdit"
    [(ngModel)]="noteText" ngModelOptions="{ updateOn: 'default blur', debounce: { default: 250, blur: 0 } }"
    ngTrim="false" class="well-textarea" placeholder="{{ 'ticket_EnterDescription_Message' | xsI18n }}"
    (focus)="setEditing(true)" (blur)="setEditing(false)">
  </textarea>
</div>

<div class="attachment-note-footer" *ngIf="isFooterVisible">
  <!-- Buttons -->
  <div class="note-footer-buttons">
    <button class="xs-btn btn-outline btn-space" (click)="cancel()">
      <span>{{ 'xs_cancel_label_short' | xsI18n }}</span>
    </button>

    <button class="xs-btn btn-primary" (click)="save()">
      <span *ngIf="isNew">{{ 'note_Add_Caption' | xsI18n }}</span>
      <span *ngIf="!isNew">{{ 'activity_Update_Caption' | xsI18n }}</span>
    </button>
  </div>
</div>